import * as React from 'react';

const IconCopy = (props: any) => (
  <svg className="icon" height="1em" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" {...props}>
    <path
      fill="currentColor"
      d="M384 336H192c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h140.1c8.5 0 16.6 3.4 22.6 9.4l51.9 51.9c6 6 9.4 14.1 9.4 22.6V304c0 17.7-14.3 32-32 32zM96 160v224c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32h32c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64v32c-17.7 0-32 14.3-32 32z"
    />
  </svg>
);

export default IconCopy;
